import { SourceOutputExampleType, sourceOutputExampleTypeToJSON } from '~/protos/agents'

export const InputOutputExamples = {
  [sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_XML)]: `
<root>
  <person>
    <name>John Doe</name>
    <age>30</age>
    <city>New York</city>
  </person>
</root>
    `.trim(),
  [sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON)]: `
{
  "person": {
    "name": "John Doe",
    "age": 30,
    "city": "New York"
  }
}
    `.trim(),
  [sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_CSV)]: `
name,age,city
John Doe,30,New York
    `.trim(),
  [sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_YAML)]: `
person:
  name: John Doe
  age: 30
  city: New York
    `.trim()
}

export const mapSourceDataTypeToLanguage = (sourceDataType: string) => {
  switch (sourceDataType) {
    case 'DATA_TYPE_EDI':
      return 'edi'
    case 'DATA_TYPE_EDIFACT':
      return 'edi'
    case 'DATA_TYPE_JSON':
      return 'json'
    case 'DATA_TYPE_CSV':
      return 'csv'
    case 'DATA_TYPE_YAML':
      return 'yaml'
    case 'DATA_TYPE_HL7':
      return 'hl7'
    case 'DATA_TYPE_XML':
      return 'xml'
    default:
      return 'plaintext'
  }
}
